import { DatePicker, DatePickerProps } from 'antd'
import React, { useState } from 'react'
import moment, { Moment } from 'moment'

type Props = {
  format: string
} & Omit<DatePickerProps, 'inputRender' | 'format'>

export const CustomAntdDatePicker = ({
  value,
  format = 'DD-MM-YYYY',
  ...props
}: Props) => {
  const [inputValue, setInputValue] = useState(
    value ? value.format(format) : '',
  )

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)
  }

  const handleBlur = () => {
    const parsed = moment(inputValue, format, true) // strict parse
    if (parsed.isValid()) {
      props.onChange?.(parsed, parsed.toString())
    } else {
      props.onChange?.(null, '')
    }
  }

  const handleChange = (date: Moment | null) => {
    setInputValue(date ? date.format(format) : '')
    props.onChange?.(date, date?.toString() ?? '')
  }

  return (
    <DatePicker
      {...props}
      format={format}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      inputRender={(props) => {
        return (
          <input
            {...props}
            onChange={(...args) => {
              props.onChange?.(...args)
              handleTextChange(args[0])
            }}
          />
        )
      }}
      inputReadOnly={false}
    />
  )
}
